/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig, withQuery } from './lais/httpHelpers';
import { VISITOR_INFO_ENDPOINTS } from './lais/endpoints';

class VisitorInfoAPI extends ApiClient {
  constructor() {
    super('visitor_info', { accountScoped: true });
  }

  show(visitorId, params = {}) {
    return axios.get(
      withQuery(resourcePath(this.url, visitorId), params),
      requestConfig()
    );
  }

  suggestions(visitorId, params = {}) {
    return axios.get(
      withQuery(
        resourcePath(this.url, visitorId, VISITOR_INFO_ENDPOINTS.suggestions),
        params
      ),
      requestConfig()
    );
  }

  houses(visitorId, params = {}) {
    return axios.get(
      withQuery(
        resourcePath(this.url, visitorId, VISITOR_INFO_ENDPOINTS.houses),
        params
      ),
      requestConfig()
    );
  }

  nextVisits(visitorId, params = {}) {
    return axios.get(
      withQuery(
        resourcePath(this.url, visitorId, VISITOR_INFO_ENDPOINTS.nextVisits),
        params
      ),
      requestConfig()
    );
  }

  lastVisits(visitorId, params = {}) {
    return axios.get(
      withQuery(
        resourcePath(this.url, visitorId, VISITOR_INFO_ENDPOINTS.lastVisits),
        params
      ),
      requestConfig()
    );
  }

  history(visitorId, params = {}) {
    return axios.get(
      withQuery(
        resourcePath(this.url, visitorId, VISITOR_INFO_ENDPOINTS.history),
        params
      ),
      requestConfig()
    );
  }

  ongoingOffers(visitorId, params = {}) {
    return axios.get(
      withQuery(
        resourcePath(this.url, visitorId, VISITOR_INFO_ENDPOINTS.ongoingOffers),
        params
      ),
      requestConfig()
    );
  }
}

export default new VisitorInfoAPI();
